import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Box, CircularProgress, Container, Typography } from "@mui/material";
import { completeLogin } from "../auth/oidc";

export default function AuthCallback() {
  const nav = useNavigate();
  const [err, setErr] = useState(null);

  useEffect(() => {
    completeLogin()
      .then(({ returnTo }) => {
        // Replace so the ?code=... URL doesn't end up in history.
        nav(returnTo || "/", { replace: true });
        // Force a reload so AuthProvider re-bootstraps with the fresh token.
        setTimeout(() => window.location.reload(), 0);
      })
      .catch((e) => setErr(e.message || "Sign in failed"));
  }, [nav]);

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      {err ? (
        <Alert severity="error">{err}</Alert>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <CircularProgress size={20} />
          <Typography>Completing sign in…</Typography>
        </Box>
      )}
    </Container>
  );
}
